"use client";
import { createContext, useEffect, useState } from "react";

export const CookieConsentContext = createContext({
  bannerClosed: false
});

function CookieConsentProvider({ children }) {
  const [bannerClosed, setBannerClosed] = useState(false);

  useEffect(() => {
    function onAccept() {
      setBannerClosed(true);
    }

    function onDecline() {
      setBannerClosed(true);
    }

    window.addEventListener("CookiebotOnAccept", onAccept);
    window.addEventListener("CookiebotOnDecline", onDecline);

    return () => {
      window.removeEventListener("CookiebotOnAccept", onAccept);
      window.removeEventListener("CookiebotOnDecline", onDecline);
    };
  }, []);

  return (
    <CookieConsentContext.Provider value={{ bannerClosed }}>
      {children}
    </CookieConsentContext.Provider>
  );
}

export default CookieConsentProvider;
